// extracted by mini-css-extract-plugin
module.exports = {"root":"AssetPreviewWrapper_root__IyG1e"};